import { reactive } from "@vue/composition-api";
import _axios from "@/axios";
import { useClientPortal } from "@/composables/client-portal";
import { handleFormErrors } from "@/composables/form-error";

export function useClientPortalBannerFooter() {
  const { currentClientPortal } = useClientPortal();

  let clientPortalBannerFooterData = reactive({
    bannerFooterFile: null,
    bannerFooterFormRef: null,
    bannerFooter_fileRules: [
      (v) => !!v || "Le nom du fichier ne peut pas être vide",
      (v) => (v && v.size < 128000) || "taille max 128 Ko",
    ],
    dialogForBannerFooter: false,
    deleteDialog: false,
    editedItem: null,
    uploadError: false,
  });

  function uploadBannerFooter(clientId, type) {
    const formData = new FormData();
    if (clientPortalBannerFooterData.bannerFooterFile instanceof Blob) {
      formData.append(
        "file",
        clientPortalBannerFooterData.bannerFooterFile,
        "upload"
      );
    }
    formData.append("type", type);

    return _axios
      .post(`/client-portal-upload/${clientId}`, formData, {
        headers: {
          "Content-Type": `multipart/form-data; boundary=${clientPortalBannerFooterData._boundary}`,
        },
      })
      .then((response) => {
        currentClientPortal.value = response.data.data;
        clientPortalBannerFooterData.uploadError = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          clientPortalBannerFooterData,
          clientPortalBannerFooterData.bannerFooterFormRef
        );
        clientPortalBannerFooterData.uploadError = true;
      });
  }

  function removeBannerFooter(clientId, type) {
    const formData = new FormData();
    formData.append("type", type);

    return _axios
      .post(`/client-portal-remove/${clientId}`, formData)
      .then((response) => {
        currentClientPortal.value = response.data.data;
      })
      .catch(() => {});
  }

  return {
    clientPortalBannerFooterData,
    uploadBannerFooter,
    removeBannerFooter,
  };
}
